import {
  ColorPicker,
  GeofenceMap,
  GeofenceModal,
  InputSearch,
} from "@wallavi/very-geofencing-library";
import { useDynamicRateContext } from "../../../../context";
import { VeryBtnFill } from "../../../common/v2/VeryBtnFill";
import { VeryIconGoogle } from "../../../common/v2/VeryIconGoogle";
import { classVeryIconGoogle } from "../../../common/v2/VeryIconGoogle/classVeryIconGoogle";
import styles from "./styles";
import { useState, useEffect } from "react";
import { classVeryBtnFill } from "../../../common/v2/VeryBtnFill/classVeryBtnFill";
import { VerySwitch } from "../../../common/v2/VerySwitch";
import { Tooltip } from "@mui/material";

const propsTemplate = () => ({
  isLoaded: false,
});

const RatePreviewChart = ({
  initialRate,
  kilometers,
  pricePerKilometer,
  isDynamic,
  priceOnDemand,
  startHour,
  endHour,
}) => {
  const baseKm = parseFloat(kilometers) || 0;
  const baseFare = parseFloat(initialRate) || 0;
  const perKm = parseFloat(pricePerKilometer) || 0;
  const demand = parseFloat(priceOnDemand) || 0;
  const showDynamic = isDynamic && perKm > 0;
  const noBaseRate = baseKm === 0 && baseFare === 0;
  const extraKmCount = 3;
  const totalKm = showDynamic
    ? Math.max(baseKm, 0) + extraKmCount
    : Math.max(baseKm, 1);
  const baseWidthPct =
    showDynamic && baseKm > 0
      ? (baseKm / totalKm) * 100
      : showDynamic
        ? 0
        : 100;
  const fracKm = Math.round((baseKm + 0.5) * 10) / 10;
  const fracFare = showDynamic ? baseFare + 0.5 * perKm : baseFare;

  return (
    <div style={{ width: "100%", paddingTop: 8 }}>
      <p
        style={{
          fontSize: 10,
          color: "#8f8f8f",
          marginBottom: 5,
          fontFamily: "Roboto",
          fontWeight: 700,
        }}
      >
        Vista previa de tarifa
      </p>

      {!showDynamic && baseFare > 0 && (
        <div
          style={{
            background: "#f0fdf4",
            border: "1px solid #86efac",
            borderRadius: 6,
            padding: "5px 10px",
            marginBottom: 6,
            fontSize: 10,
            color: "#166534",
            fontFamily: "Roboto",
          }}
        >
          <strong>Tarifa fija activa:</strong> todos los viajes en esta área
          cuestan <strong>${baseFare} MXN</strong> sin importar la distancia.
          Activa &quot;Tarifa Dinámica&quot; para cobrar por km extra.
        </div>
      )}

      {noBaseRate && !showDynamic && (
        <div
          style={{
            background: "#fafafa",
            border: "1px dashed #ccc",
            borderRadius: 6,
            padding: "8px 12px",
            fontSize: 10,
            color: "#999",
            fontFamily: "Roboto",
            marginBottom: 6,
            textAlign: "center",
          }}
        >
          Sin tarifa base configurada. Activa &quot;Tarifa Dinámica&quot; para
          cobrar por km.
        </div>
      )}
      <div
        style={{
          display: "flex",
          width: "100%",
          height: 52,
          borderRadius: 8,
          overflow: "hidden",
          border: "1px solid #e0e0e0",
        }}
      >
        {baseKm > 0 && (
          <div
            style={{
              width: `${baseWidthPct}%`,
              background: "linear-gradient(135deg, #f7af36 0%, #f59e0b 100%)",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              borderRight: showDynamic ? "2px solid white" : "none",
              minWidth: 60,
            }}
          >
            <span
              style={{
                fontSize: 11,
                fontWeight: 700,
                color: "white",
                fontFamily: "Roboto",
              }}
            >
              ${baseFare}
            </span>
            <span
              style={{
                fontSize: 9,
                color: "rgba(255,255,255,0.9)",
                fontFamily: "Roboto",
              }}
            >
              {`primeros ${baseKm} km`}
            </span>
          </div>
        )}
        {showDynamic &&
          Array.from({ length: extraKmCount }, (_, i) => (
            <div
              key={i}
              style={{
                flex: 1,
                background: i % 2 === 0 ? "#ef4444" : "#dc2626",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                borderRight:
                  i < extraKmCount - 1
                    ? "1px solid rgba(255,255,255,0.3)"
                    : "none",
              }}
            >
              <span
                style={{
                  fontSize: 10,
                  fontWeight: 700,
                  color: "white",
                  fontFamily: "Roboto",
                }}
              >
                +${perKm}
              </span>
              <span
                style={{
                  fontSize: 9,
                  color: "rgba(255,255,255,0.8)",
                  fontFamily: "Roboto",
                }}
              >
                /km
              </span>
            </div>
          ))}
      </div>

      {showDynamic && (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: 3,
          }}
        >
          <span style={{ fontSize: 9, color: "#8f8f8f", fontFamily: "Roboto" }}>
            0
          </span>
          {baseKm > 0 && (
            <span
              style={{ fontSize: 9, color: "#8f8f8f", fontFamily: "Roboto" }}
            >
              {baseKm} km
            </span>
          )}
          {Array.from({ length: extraKmCount }, (_, i) => (
            <span
              key={i}
              style={{ fontSize: 9, color: "#8f8f8f", fontFamily: "Roboto" }}
            >
              {baseKm + i + 1} km
            </span>
          ))}
        </div>
      )}

      <div
        style={{
          marginTop: 8,
          fontSize: 10,
          color: "#444",
          background: "#f9f9f9",
          padding: "6px 10px",
          borderRadius: 6,
          fontFamily: "Roboto",
          lineHeight: 1.7,
        }}
      >
        <strong>Ejemplos de cobro:</strong>
        <br />
        {baseKm > 0 && (
          <span>
            {baseKm} km → <strong>${baseFare.toFixed(2)} MXN</strong>
          </span>
        )}
        {showDynamic ? (
          <>
            {" | "}
            <span>
              {fracKm} km → <strong>${fracFare.toFixed(2)} MXN</strong>
            </span>
            {" | "}
            <span>
              {baseKm + 1} km →{" "}
              <strong>${(baseFare + perKm).toFixed(2)} MXN</strong>
            </span>
            {" | "}
            <span>
              {baseKm + 2} km →{" "}
              <strong>${(baseFare + 2 * perKm).toFixed(2)} MXN</strong>
            </span>
          </>
        ) : baseFare > 0 ? (
          <>
            {" | "}
            <span>
              {baseKm + 5} km → <strong>${baseFare.toFixed(2)} MXN</strong>
            </span>
            {" | "}
            <span>
              {baseKm + 20} km → <strong>${baseFare.toFixed(2)} MXN</strong>
            </span>
          </>
        ) : null}
      </div>

      {showDynamic && (
        <p
          style={{
            marginTop: 3,
            fontSize: 9,
            color: "#8f8f8f",
            fontFamily: "Roboto",
          }}
        >
          * Los km adicionales se cobran por fracción real (ej: {fracKm} km ={" "}
          <strong>${fracFare.toFixed(2)} MXN</strong> — no se redondea al km
          completo).
        </p>
      )}

      {demand > 0 && startHour && endHour && (
        <div
          style={{
            marginTop: 4,
            fontSize: 10,
            color: "#7c3aed",
            background: "#f5f3ff",
            padding: "5px 10px",
            borderRadius: 6,
            fontFamily: "Roboto",
          }}
        >
          + ${demand} MXN adicional en horario especial ({startHour} a {endHour}
          )
        </div>
      )}
    </div>
  );
};

const ModalAddRate = (props = propsTemplate()) => {
  const dynamicRate = useDynamicRateContext();
  const [mode, setMode] = useState("new");
  const [drawingPoints, setDrawingPoints] = useState([]);
  
  const [startHourHH, setStartHourHH] = useState("");
  const [startHourMM, setStartHourMM] = useState("");
  const [startHourPeriod, setStartHourPeriod] = useState("AM");
  const [endHourHH, setEndHourHH] = useState("");
  const [endHourMM, setEndHourMM] = useState("");
  const [endHourPeriod, setEndHourPeriod] = useState("AM");

  const [startHour2HH, setStartHour2HH] = useState("");
  const [startHour2MM, setStartHour2MM] = useState("");
  const [startHour2Period, setStartHour2Period] = useState("AM");
  const [endHour2HH, setEndHour2HH] = useState("");
  const [endHour2MM, setEndHour2MM] = useState("");
  const [endHour2Period, setEndHour2Period] = useState("AM");

  const [zoom, setZoom] = useState(14);
  const [stepError, setStepError] = useState("");

  const splitHour = (time) => {
    if (!time) return { hour: "", minute: "", period: "AM" };
    const regex = /^(\d{1,2}):(\d{2})\s?(AM|PM)$/i;
    const match = time.match(regex);
    if (!match) return { hour: "", minute: "", period: "AM" };
    return {
      hour: match[1],
      minute: match[2],
      period: match[3].toUpperCase(),
    };
  };

  useEffect(() => {
    if (dynamicRate.valueModal.show) {
      const hasPolygons =
        Array.isArray(dynamicRate.data.polygons) &&
        dynamicRate.data.polygons.length > 0;
      setMode(hasPolygons ? "preview" : "new");
      setDrawingPoints([]);
      setStepError("");
    }
  }, [dynamicRate.valueModal.show]);

  useEffect(() => {
    if (dynamicRate.valueModal.show && dynamicRate.data) {
      const start = splitHour(dynamicRate.data.startHour);
      setStartHourHH(start.hour);
      setStartHourMM(start.minute);
      setStartHourPeriod(start.period);

      const end = splitHour(dynamicRate.data.endHour);
      setEndHourHH(end.hour);
      setEndHourMM(end.minute);
      setEndHourPeriod(end.period);

      const start2 = splitHour(dynamicRate.data.startHour2);
      setStartHour2HH(start2.hour);
      setStartHour2MM(start2.minute);
      setStartHour2Period(start2.period);

      const end2 = splitHour(dynamicRate.data.endHour2);
      setEndHour2HH(end2.hour);
      setEndHour2MM(end2.minute);
      setEndHour2Period(end2.period);
    }
  }, [dynamicRate.valueModal.show]);

  const updateStartHour = (hh, mm, period) => {
    setStartHourHH(hh);
    setStartHourMM(mm);
    setStartHourPeriod(period);
    const h = hh === "" ? "00" : hh;
    const m = mm === "" ? "00" : mm;
    const formatted = `${h.padStart(2, "0")}:${m.padStart(2, "0")} ${period}`;
    dynamicRate.updateData({ startHour: formatted });
  };

  const updateEndHour = (hh, mm, period) => {
    setEndHourHH(hh);
    setEndHourMM(mm);
    setEndHourPeriod(period);
    const h = hh === "" ? "00" : hh;
    const m = mm === "" ? "00" : mm;
    const formatted = `${h.padStart(2, "0")}:${m.padStart(2, "0")} ${period}`;
    dynamicRate.updateData({ endHour: formatted });
  };

  const updateStartHour2 = (hh, mm, period) => {
    setStartHour2HH(hh);
    setStartHour2MM(mm);
    setStartHour2Period(period);
    const h = hh === "" ? "00" : hh;
    const m = mm === "" ? "00" : mm;
    const formatted = `${h.padStart(2, "0")}:${m.padStart(2, "0")} ${period}`;
    dynamicRate.updateData({ startHour2: formatted });
  };

  const updateEndHour2 = (hh, mm, period) => {
    setEndHour2HH(hh);
    setEndHour2MM(mm);
    setEndHour2Period(period);
    const h = hh === "" ? "00" : hh;
    const m = mm === "" ? "00" : mm;
    const formatted = `${h.padStart(2, "0")}:${m.padStart(2, "0")} ${period}`;
    dynamicRate.updateData({ endHour2: formatted });
  };

  return (
    <styles.DivMain
      isVisible={dynamicRate.valueModal.show}
      onClickBtnClose={() => dynamicRate.hideModal()}
      stepSelected={dynamicRate.valueModal.stepSelected}
    >
      {dynamicRate.valueModal.stepSelected === 1 && (
        <styles.PanelName>
          <div className="divCircleStep">
            <p>{dynamicRate.valueModal.stepSelected}</p>
          </div>

          <p>Crea tu nueva tarifa dinámica</p>
          <input
            type="text"
            placeholder="Agrega el nombre"
            onChange={(newName) => {
              setStepError("");
              dynamicRate.updateData({
                name: newName.target.value,
              });
            }}
          />
          {stepError && (
            <p style={{ color: "#ef4444", fontSize: 12, margin: "4px 0 0" }}>
              {stepError}
            </p>
          )}
          <button
            className="buttonNext"
            onClick={() => {
              if (
                !dynamicRate.data.name ||
                dynamicRate.data.name.trim() === ""
              ) {
                setStepError("El nombre es requerido");
                return;
              }
              setStepError("");
              dynamicRate.setStepSelected(2);
            }}
          >
            <p>Siguiente</p>
            <VeryIconGoogle
              name="chevron_right"
              type="symbolsOutlined"
              size={20}
              color={classVeryIconGoogle.ICON_COLOR.WHITE_S1}
            />
          </button>
        </styles.PanelName>
      )}
      {dynamicRate.valueModal.stepSelected === 2 && (
        <styles.PanelUbication>
          <div className="divCircleStep">
            <p>{dynamicRate.valueModal.stepSelected}</p>
          </div>
          <p>Elije el lugar donde se activara</p>
          <InputSearch
            CSS={["inputUbication"]}
            isLoaded={props.isLoaded}
            value={dynamicRate.data.ubicationName}
            onSelectLocation={async (ubicationInfo) => {
              dynamicRate.updateData({
                ubicationName: ubicationInfo.name,
                ubicationCoordinates: {
                  lat: parseFloat(ubicationInfo.lat),
                  lng: parseFloat(ubicationInfo.lng),
                },
              });

              if (ubicationInfo.isCity) {
                const paths = await dynamicRate.getPaths(ubicationInfo.name); // ✅ esperar la promesa
                dynamicRate.updateData({
                  polygons: paths,
                });
                setMode("edit");
                setZoom(8);
              }
            }}
          />
          {stepError && (
            <p style={{ color: "#ef4444", fontSize: 12, margin: "4px 0 0" }}>
              {stepError}
            </p>
          )}
          <div className="divButtons" style={{ marginTop: "40px" }}>
            <button
              className="buttonBack"
              onClick={() => {
                setStepError("");
                dynamicRate.setStepSelected(1);
              }}
            >
              <VeryIconGoogle
                name="chevron_left"
                type="symbolsOutlined"
                size={20}
                color={classVeryIconGoogle.ICON_COLOR.GRAY_S1}
              />
              <p>Atras</p>
            </button>
            <button
              className="buttonNext"
              onClick={() => {
                setStepError("");
                dynamicRate.setStepSelected(2.5);
                if (mode !== "edit") {
                  setMode("new");
                }
              }}
            >
              <p>Siguiente</p>
              <VeryIconGoogle
                name="chevron_right"
                type="symbolsOutlined"
                size={20}
                color={classVeryIconGoogle.ICON_COLOR.WHITE_S1}
              />
            </button>
          </div>
        </styles.PanelUbication>
      )}
      {dynamicRate.valueModal.stepSelected === 2.5 && (
        <styles.PanelUbicationMap>
          <div className="headerDiv">
            <div className="divCircleStep">
              <p>{Math.floor(dynamicRate.valueModal.stepSelected)}</p>
            </div>
            <p>Traza el área de cobertura de la tarifa</p>
          </div>
          <div className="divUbicationMap">
            <GeofenceMap
              mode={mode}
              zoom={zoom}
              width="720px"
              height="450px"
              singlePolygon={
                (mode === "view" || mode === "edit") &&
                Array.isArray(dynamicRate.data.polygons) &&
                dynamicRate.data.polygons.length > 0
                  ? { color: "orange", polygons: dynamicRate.data.polygons }
                  : null
              }
              createdPolygon={
                mode === "preview" &&
                Array.isArray(dynamicRate.data.polygons) &&
                dynamicRate.data.polygons.length > 0
                  ? dynamicRate.data.polygons
                  : undefined
              }
              drawingPoints={mode === "new" ? drawingPoints : undefined}
              onMapClick={
                mode === "new"
                  ? (pt) => setDrawingPoints((prev) => [...prev, pt])
                  : undefined
              }
              isLoaded={props.isLoaded}
              center={dynamicRate.data.ubicationCoordinates}
              onPolygonUpdate={(polygon) =>
                dynamicRate.updateData({ polygons: polygon })
              }
              onPolygonComplete={(polygon) => {
                dynamicRate.updateData({ polygons: polygon });
                if (polygon.length > 0) setMode("preview");
              }}
            />
            <div className="divControl">
              <span className="name">
                {mode === "new"
                  ? drawingPoints.length === 0
                    ? "↓ Haz clic en el mapa para agregar vértices"
                    : `${drawingPoints.length} punto${drawingPoints.length !== 1 ? "s" : ""} — mínimo 3 para finalizar`
                  : mode === "preview"
                    ? "Geocerca lista ✓"
                    : "Ajusta los vértices"}
              </span>
              {mode === "new" && drawingPoints.length > 0 && (
                <button
                  className="btnUndo"
                  title="Deshacer último punto"
                  onClick={() => setDrawingPoints((prev) => prev.slice(0, -1))}
                >
                  <VeryIconGoogle
                    name="undo"
                    type={classVeryIconGoogle.ICON_TYPE.SYMBOLS_OUTLINED}
                    size={18}
                    color={classVeryIconGoogle.ICON_COLOR.WHITE_S1}
                  />
                </button>
              )}
              {mode === "new" && drawingPoints.length > 0 && (
                <button
                  className="btnClear"
                  title="Limpiar todos los puntos"
                  onClick={() => setDrawingPoints([])}
                >
                  <VeryIconGoogle
                    name="delete"
                    type={classVeryIconGoogle.ICON_TYPE.FILLED}
                    size={18}
                    color={classVeryIconGoogle.ICON_COLOR.WHITE_S1}
                  />
                </button>
              )}
              {mode === "new" && drawingPoints.length >= 3 && (
                <button
                  className="btnFinish"
                  title="Finalizar área"
                  onClick={() => {
                    dynamicRate.updateData({ polygons: drawingPoints });
                    setMode("preview");
                    setDrawingPoints([]);
                  }}
                >
                  <VeryIconGoogle
                    name="check_circle"
                    type={classVeryIconGoogle.ICON_TYPE.OUTLINED}
                    size={16}
                    color={classVeryIconGoogle.ICON_COLOR.WHITE_S1}
                  />
                  <span className="label-text">Listo</span>
                </button>
              )}
              {mode === "preview" && (
                <button
                  className="btnFinish"
                  title="Editar vértices"
                  onClick={() => setMode("edit")}
                >
                  <VeryIconGoogle
                    name="edit"
                    type={classVeryIconGoogle.ICON_TYPE.OUTLINED}
                    size={16}
                    color={classVeryIconGoogle.ICON_COLOR.WHITE_S1}
                  />
                  <span className="label-text">Editar</span>
                </button>
              )}
              {mode === "edit" && (
                <button
                  className="btnFinish"
                  title="Confirmar edición"
                  onClick={() => setMode("preview")}
                >
                  <VeryIconGoogle
                    name="check_circle"
                    type={classVeryIconGoogle.ICON_TYPE.OUTLINED}
                    size={16}
                    color={classVeryIconGoogle.ICON_COLOR.WHITE_S1}
                  />
                  <span className="label-text">Listo</span>
                </button>
              )}
              {mode !== "new" && (
                <button
                  className="btnReset"
                  title="Borra toda la geocerca y te permite dibujar una nueva desde cero"
                  onClick={() => {
                    dynamicRate.updateData({ polygons: [] });
                    setMode("new");
                    setDrawingPoints([]);
                  }}
                >
                  <VeryIconGoogle
                    name="delete_sweep"
                    type={classVeryIconGoogle.ICON_TYPE.OUTLINED}
                    size={16}
                    color={classVeryIconGoogle.ICON_COLOR.WHITE_S1}
                  />
                  <span className="label-text">Redibujar</span>
                </button>
              )}
            </div>
          </div>
          {stepError && (
            <p style={{ color: "#ef4444", fontSize: 12, margin: "4px 0 0" }}>
              {stepError}
            </p>
          )}
          <div className="divButtons" style={{ marginTop: "40px" }}>
            {!dynamicRate.valueModal.editGeofenceOnly && (
              <button
                className="buttonBack"
                onClick={() => {
                  setStepError("");
                  dynamicRate.setStepSelected(2);
                  setMode("new");
                }}
              >
                <VeryIconGoogle
                  name="chevron_left"
                  type="symbolsOutlined"
                  size={20}
                  color={classVeryIconGoogle.ICON_COLOR.GRAY_S1}
                />
                <p>Atras</p>
              </button>
            )}
            {dynamicRate.valueModal.editGeofenceOnly ? (
              <button
                className="buttonNext"
                disabled={
                  !Array.isArray(dynamicRate.data.polygons) ||
                  dynamicRate.data.polygons.length < 3
                }
                style={{
                  opacity:
                    Array.isArray(dynamicRate.data.polygons) &&
                    dynamicRate.data.polygons.length >= 3
                      ? 1
                      : 0.4,
                  cursor:
                    Array.isArray(dynamicRate.data.polygons) &&
                    dynamicRate.data.polygons.length >= 3
                      ? "pointer"
                      : "not-allowed",
                }}
                onClick={() => {
                  setStepError("");
                  dynamicRate.hideModal();
                }}
              >
                <p>Guardar geocerca</p>
                <VeryIconGoogle
                  name="check_circle"
                  type={classVeryIconGoogle.ICON_TYPE.SYMBOLS_OUTLINED}
                  size={20}
                  color={classVeryIconGoogle.ICON_COLOR.WHITE_S1}
                />
              </button>
            ) : (
              <button
                className="buttonNext"
                disabled={
                  !Array.isArray(dynamicRate.data.polygons) ||
                  dynamicRate.data.polygons.length < 3
                }
                style={{
                  opacity:
                    Array.isArray(dynamicRate.data.polygons) &&
                    dynamicRate.data.polygons.length >= 3
                      ? 1
                      : 0.4,
                  cursor:
                    Array.isArray(dynamicRate.data.polygons) &&
                    dynamicRate.data.polygons.length >= 3
                      ? "pointer"
                      : "not-allowed",
                }}
                onClick={() => {
                  const polygons = dynamicRate.data.polygons;
                  if (!Array.isArray(polygons) || polygons.length < 3) {
                    setStepError(
                      'Dibuja el área (mínimo 3 puntos) y confirma con "Listo"',
                    );
                    return;
                  }
                  setStepError("");
                  dynamicRate.setStepSelected(3);
                }}
              >
                <p>Siguiente</p>
                <VeryIconGoogle
                  name="chevron_right"
                  type="symbolsOutlined"
                  size={20}
                  color={classVeryIconGoogle.ICON_COLOR.WHITE_S1}
                />
              </button>
            )}
          </div>
        </styles.PanelUbicationMap>
      )}
      {dynamicRate.valueModal.stepSelected === 3 && (
        <styles.PanelRateDynamic>
          {/* ── Header ── */}
          <div className="headerDiv">
            <div className="divCircleStep">
              <p>3</p>
            </div>
            <p style={{ fontWeight: 700, fontSize: 16, color: "#13131d" }}>
              Configura la tarifa
            </p>
          </div>

          {/* ── 2-column grid ── */}
          <div className="gridLayout">
            {/* LEFT column */}
            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
              {/* Tarifa Base */}
              <div className="sectionCard">
                <span className="titleSection">Tarifa base del viaje</span>
                <div className="divBaseRate">
                  <div className="inputGroup">
                    <label className="inputLabel">
                      Monto base{" "}
                      {!dynamicRate.data.isDynamic && (
                        <span style={{ color: "#ef4444" }}>*</span>
                      )}
                      <Tooltip
                        title="Costo fijo al inicio de cada viaje. Si no usas tarifa dinámica, este es el único cobro independientemente de la distancia."
                        placement="top"
                      >
                        <div style={{ display: "flex", cursor: "help" }}>
                          <VeryIconGoogle
                            name="info"
                            type={classVeryIconGoogle.ICON_TYPE.OUTLINED}
                            size={13}
                            color={classVeryIconGoogle.ICON_COLOR.GRAY_S1}
                          />
                        </div>
                      </Tooltip>
                    </label>
                    <div className="inputWithUnit">
                      <span>$</span>
                      <input
                        type="text"
                        placeholder="0.00"
                        onChange={(e) => {
                          setStepError("");
                          dynamicRate.updateData({
                            initialRate:
                              e.target.value === "" ? 0 : e.target.value,
                          });
                        }}
                      />
                      <span>MXN</span>
                    </div>
                  </div>
                  <div className="inputGroup">
                    <label className="inputLabel">
                      Km incluidos
                      <Tooltip
                        title="Kilómetros cubiertos por la tarifa base. Si el viaje los supera y la tarifa dinámica está activa, se cobra extra por km adicional."
                        placement="top"
                      >
                        <div style={{ display: "flex", cursor: "help" }}>
                          <VeryIconGoogle
                            name="info"
                            type={classVeryIconGoogle.ICON_TYPE.OUTLINED}
                            size={13}
                            color={classVeryIconGoogle.ICON_COLOR.GRAY_S1}
                          />
                        </div>
                      </Tooltip>
                    </label>
                    <div className="inputWithUnit">
                      <input
                        type="text"
                        placeholder="0"
                        onChange={(e) =>
                          dynamicRate.updateData({
                            kilometers:
                              e.target.value === "" ? 0 : e.target.value,
                          })
                        }
                      />
                      <span>km</span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Tarifa Dinámica */}
              <div className="sectionCard">
                <span className="titleSection">Cobro por km adicional</span>
                <div
                  className="headerDiv"
                  style={{ marginBottom: 0, marginTop: 2 }}
                >
                  <VerySwitch
                    selected={dynamicRate.data.isDynamic}
                    onChangeSelected={(isDynamic) => {
                      setStepError("");
                      dynamicRate.updateData({ isDynamic });
                    }}
                  />
                  <span
                    style={{
                      fontWeight: 700,
                      fontSize: 13,
                      color: "#13131d",
                    }}
                  >
                    Tarifa Dinámica
                  </span>
                  <Tooltip
                    title="Al activar, se cobra un extra por cada km que supere los km incluidos. Desactiva para cobrar siempre el monto base fijo sin importar la distancia."
                    placement="top"
                  >
                    <div>
                      <VeryIconGoogle
                        name="info"
                        type={classVeryIconGoogle.ICON_TYPE.OUTLINED}
                        size={16}
                        color={classVeryIconGoogle.ICON_COLOR.GRAY_S1}
                      />
                    </div>
                  </Tooltip>
                </div>
                <div
                  className="priceKmDiv"
                  style={{
                    opacity: dynamicRate.data.isDynamic ? 1 : 0.35,
                    transition: "opacity 0.2s",
                  }}
                >
                  <span>
                    $ por km adicional{" "}
                    {dynamicRate.data.isDynamic && (
                      <span style={{ color: "#ef4444" }}>*</span>
                    )}
                  </span>
                  <div className="divInputs">
                    <span>$</span>
                    <input
                      type="text"
                      placeholder="0.00"
                      disabled={!dynamicRate.data.isDynamic}
                      onChange={(e) => {
                        setStepError("");
                        dynamicRate.updateData({
                          pricePerKilometer: e.target.value,
                        });
                      }}
                    />
                    <span>/ km</span>
                  </div>
                </div>
              </div>
            </div>

            {/* RIGHT column */}
            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
              <div className="sectionCard" style={{ padding: "16px", display: "flex", flexDirection: "column", gap: 8 }}>
                <div style={{ display: "flex", alignItems: "center", gap: "6px", color: "#f57c00", fontWeight: "700" }}>
                  <VeryIconGoogle
                    name="info"
                    type={classVeryIconGoogle.ICON_TYPE.OUTLINED}
                    size={18}
                    color={classVeryIconGoogle.ICON_COLOR.ORANGE_S1}
                  />
                  <span style={{ fontSize: "13px" }}>Tarifas por horarios generales</span>
                </div>
                <span style={{ fontSize: "12px", color: "#6b7280", lineHeight: "1.5" }}>
                  Las tarifas nocturnas generales configuradas en el sistema se sumarán y aplicarán automáticamente por defecto sobre los viajes de esta geocerca:
                </span>
                <div style={{ display: "flex", flexDirection: "column", gap: "4px", backgroundColor: "#fff", padding: "8px 12px", borderRadius: "6px", border: "1px solid #ffe0b2" }}>
                  {dynamicRate.generalNightTariff1?.active ? (
                    <div style={{ display: "flex", justifyContent: "space-between", fontSize: "12px" }}>
                      <span><strong>Tarifa Nocturna 1:</strong> {dynamicRate.generalNightTariff1.startHour} a {dynamicRate.generalNightTariff1.endHour}</span>
                      <span style={{ color: "#e65100", fontWeight: "700" }}>+{dynamicRate.generalNightTariff1.increment} MXN</span>
                    </div>
                  ) : null}
                  {dynamicRate.generalNightTariff2?.active ? (
                    <div style={{ display: "flex", justifyContent: "space-between", fontSize: "12px", borderTop: dynamicRate.generalNightTariff1?.active ? "1px solid #ffe0b2" : "none", paddingTop: dynamicRate.generalNightTariff1?.active ? "4px" : "0" }}>
                      <span><strong>Tarifa Nocturna 2:</strong> {dynamicRate.generalNightTariff2.startHour} a {dynamicRate.generalNightTariff2.endHour}</span>
                      <span style={{ color: "#e65100", fontWeight: "700" }}>+{dynamicRate.generalNightTariff2.increment} MXN</span>
                    </div>
                  ) : null}
                  {!dynamicRate.generalNightTariff1?.active && !dynamicRate.generalNightTariff2?.active ? (
                    <span style={{ fontSize: "12px", color: "#888", fontStyle: "italic" }}>No hay tarifas nocturnas generales activas actualmente.</span>
                  ) : null}
                </div>
              </div>

              {/* Apariencia y Prioridad */}
              <div className="sectionCard">
                <span className="titleSection">Apariencia y prioridad</span>
                <div className="divColorPriority">
                  <div className="divColorGroup">
                    <label className="inputLabel">
                      Color de geocerca
                      <Tooltip
                        title="Color con el que se muestra la geocerca en el mapa. Haz clic en el círculo de color para cambiar."
                        placement="top"
                      >
                        <div style={{ display: "flex", cursor: "help" }}>
                          <VeryIconGoogle
                            name="info"
                            type={classVeryIconGoogle.ICON_TYPE.OUTLINED}
                            size={13}
                            color={classVeryIconGoogle.ICON_COLOR.GRAY_S1}
                          />
                        </div>
                      </Tooltip>
                    </label>
                    <ColorPicker
                      valueColor={dynamicRate.data.color}
                      onChangeColor={(color) =>
                        dynamicRate.updateData({ color })
                      }
                    />
                  </div>
                  <div className="divPriorityGroup">
                    <label className="inputLabel">
                      Prioridad <span style={{ color: "#ef4444" }}>*</span>
                      <Tooltip
                        title="Cuando un viaje coincide con varias geocercas, se aplica la de mayor prioridad. 1 = máxima prioridad, 3 = mínima."
                        placement="top"
                      >
                        <div style={{ display: "flex", cursor: "help" }}>
                          <VeryIconGoogle
                            name="info"
                            type={classVeryIconGoogle.ICON_TYPE.OUTLINED}
                            size={13}
                            color={classVeryIconGoogle.ICON_COLOR.GRAY_S1}
                          />
                        </div>
                      </Tooltip>
                    </label>
                    <div className="divPrioritySelect">
                      <select
                        value={dynamicRate.data.priority}
                        onChange={(e) =>
                          dynamicRate.updateData({ priority: e.target.value })
                        }
                      >
                        <option value="principal">
                          1 — Principal (máxima)
                        </option>
                        <option value="secundario">2 — Secundaria</option>
                        <option value="terciario">
                          3 — Terciaria (mínima)
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* ── Vista Previa ── */}
          <RatePreviewChart
            initialRate={dynamicRate.data.initialRate}
            kilometers={dynamicRate.data.kilometers}
            pricePerKilometer={dynamicRate.data.pricePerKilometer}
            isDynamic={dynamicRate.data.isDynamic}
            priceOnDemand={dynamicRate.data.priceOnDemand}
            startHour={dynamicRate.data.startHour}
            endHour={dynamicRate.data.endHour}
          />

          {stepError && (
            <p style={{ color: "#ef4444", fontSize: 12, margin: "4px 0 0" }}>
              {stepError}
            </p>
          )}
          <div className="divButtons">
            <button
              className="buttonBack"
              onClick={() => {
                setStepError("");
                dynamicRate.setStepSelected(2.5);
              }}
            >
              <VeryIconGoogle
                name="chevron_left"
                type={classVeryIconGoogle.ICON_TYPE.OUTLINED}
                size={20}
                color={classVeryIconGoogle.ICON_COLOR.GRAY_S1}
              />
              <p>Atras</p>
            </button>
            <button
              className="buttonNext"
              disabled={
                (!dynamicRate.data.isDynamic &&
                  parseFloat(dynamicRate.data.initialRate) === 0) ||
                (dynamicRate.data.isDynamic &&
                  parseFloat(dynamicRate.data.pricePerKilometer) === 0)
              }
              style={{
                opacity:
                  (!dynamicRate.data.isDynamic &&
                    parseFloat(dynamicRate.data.initialRate) !== 0) ||
                  (dynamicRate.data.isDynamic &&
                    parseFloat(dynamicRate.data.pricePerKilometer) !== 0)
                    ? 1
                    : 0.4,
                cursor:
                  (!dynamicRate.data.isDynamic &&
                    parseFloat(dynamicRate.data.initialRate) !== 0) ||
                  (dynamicRate.data.isDynamic &&
                    parseFloat(dynamicRate.data.pricePerKilometer) !== 0)
                    ? "pointer"
                    : "not-allowed",
              }}
              onClick={() => {
                const ir = parseFloat(dynamicRate.data.initialRate) || 0;
                const pkm = parseFloat(dynamicRate.data.pricePerKilometer) || 0;
                if (!dynamicRate.data.isDynamic && ir === 0) {
                  setStepError(
                    "Monto base requerido: sin tarifa fija ni precio por km los viajes serían gratis.",
                  );
                  return;
                }
                if (dynamicRate.data.isDynamic && pkm === 0) {
                  setStepError(
                    "La tarifa dinámica requiere un precio por km mayor a $0.",
                  );
                  return;
                }
                if (
                  dynamicRate.data.isDemand &&
                  !(parseFloat(dynamicRate.data.priceOnDemand) > 0)
                ) {
                  setStepError(
                    "La tarifa sobre demanda requiere un precio mayor a $0.",
                  );
                  return;
                }
                setStepError("");
                dynamicRate.setStepSelected(4);
                setMode("new");
              }}
            >
              <p>Siguiente</p>
              <VeryIconGoogle
                name="chevron_right"
                type={classVeryIconGoogle.ICON_TYPE.OUTLINED}
                size={20}
                color={classVeryIconGoogle.ICON_COLOR.WHITE_S1}
              />
            </button>
          </div>
        </styles.PanelRateDynamic>
      )}
      {dynamicRate.valueModal.stepSelected === 4 && (
        <styles.PanelFinish>
          <h3>!Felicidades haz creado una nueva tarifa!</h3>
          <div className="divSubtitle">
            <VerySwitch
              selected={dynamicRate.data.isActivate}
              onChangeSelected={(isActivate) => {
                dynamicRate.updateData({
                  isActivate: isActivate,
                });
              }}
            />
            <p>
              Recuerda que la puedes activar o desactivar dando directo desde el
              dashboard
            </p>
          </div>
          <button
            className="btnEnd"
            disabled={dynamicRate.valueModal.loading}
            onClick={() => dynamicRate.onClickBtnAdd()}
          >
            <p>
              {dynamicRate.valueModal.loading ? "Guardando..." : "Finalizar"}
            </p>
          </button>
        </styles.PanelFinish>
      )}
    </styles.DivMain>
  );
};

export default ModalAddRate;
